// extracted by mini-css-extract-plugin
export default {"hoverdropdown":"Navbar_hoverdropdown__jvsq8","dropdown":"Navbar_dropdown__aG1al"};